import axios from "axios";
import { useEffect } from "react";
import { createContext, useState } from "react";

export const GamesContext = createContext()

export const GamesProvider = (props) => {
    const [listGame, setListGame] = useState([])
    useEffect(()=>{
        const games = async () => {
            const result = await axios.get("https://super-bootcamp-backend.sanbersy.com/api/games")
                .then((res) => {
                    return res.data
                })
                .catch((err) =>{
                    console.log(err)
                })
    
            setListGame(result)
            // console.log(result)
        }

        games()
    }, [])
   
    return(
        <GamesContext.Provider value={[listGame, setListGame]}>
            {props.children}
         </GamesContext.Provider>
    )
    
}